import Mock from 'mockjs'
import qs from 'qs'

const userDB = [
    {
        username: 'admin',
        password: 'admin',
        uuid: 'admin-uuid',
        name: '应用商店用户',
        role: 'appstore' //role字段为新增，用于区分“应用商店”和“分中心”
    },
    {
        username: 'center',
        password: 'center',
        uuid: 'center-uuid',
        name: '分中心用户',
        role: 'center'
    },
    {
        username: 'appstore',
        password: 'appstore',
        uuid: 'appstore-uuid',
        name: '应用商店用户',
        role: 'appstore' //role字段为新增，用于区分“应用商店”和“分中心”
    },
    {
        username: 'user1',
        password: 'user1',
        uuid: 'user1-uuid',
        name: '用户1'
    }
]

Mock.mock('/login', 'post', ({url, type, body}) => {
    //const bodyObj = JSON.parse(body)
    const bodyObj = qs.parse(body)
    const user = userDB.find(e => e.username === bodyObj.username && e.password === bodyObj.password)
    if (user) {
        return {
            code: 0,
            msg: '登陆成功',
            data: {
                ...user,
                token: 'd787syv8dys8cas80d9s0a0d8f79ads56f7s4d56f879a8as89fd980s7dg'
            }
        }
    } else {
        return {
            code: 401,
            msg: '用户名或密码错误'
        }
    }
})

Mock.mock('/service/sso/keyPair', 'get', ({url, type, body}) => {
    console.log('模拟：/service/sso/keyPair')
    return {
        "code": 200,
        "message": "成功",
        "body": {
            "modulus": "009a8811dc11830c4fe224e4a95847cb6fa13ab1b586f4cb757dc9c6f55a7880e91bb750a0a75324d4c0b5d5e573223e8903cfb2b5ebd72883bf777817e28b57989c34c86bc45017f7db21d93576728c3eaa97f5cc14319e280e3e4d6c8b03c9da05b6c051309295d5c4835cf6e1c607f8e5104008a43fd865528fac98dfd75e45",
            "exponent": "010001"
        },
        "timestamp": 1543996615342
    }
})

Mock.mock('/service/sso/login', 'post', ({url, type, body}) => {
    console.log('模拟：/service/sso/login')
    return {
        "code": 200,
        "message": "成功",
        "body": {
            "user": {
                "id": 3,
                "userName": "admin",
                "realName": "管理员"
            }
        },
        "timestamp": 1543996615342
    }
})

Mock.mock('/service/sso/logout', () => {
    console.log('模拟：/service/sso/logout')
    return {"code": 200, "message": "成功", "body": true, "timestamp": 1543997351104}
})

Mock.mock('/service/sso/code', () => {
    console.log('模拟：/service/sso/code')
    return {"code": 200, "message": "成功", "body": false, "timestamp": 1543997444569}
})
